export default "__VITE_ASSET__20be74f7__"